export default __webpack_public_path__ + "static/media/151-winch.f23830dd.png";